import { t } from "i18next";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../Component/NavbarTop";
import Sidebar from "../Component/Sidebar";
import "./CourseList.css";
import { getCookie } from "../../Cookies";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Cdata } from "./CourseData";
import { Checkbox } from "@mui/material";

function CourseList() {
  const [data, setData] = useState(Cdata);
  const { clrs } = useSelector((state) => state.createClr);
  const navigate = useNavigate();
  const goToHome = () => navigate("/");

  // useEffect(() => {
  //   if (getCookie("UID") == null || getCookie("ROLE") != "admin") {
  //     goToHome();
  //     return <></>;
  //   }
  // });

  const [arr, setArr] = useState();
  const [pageNo, setPageNo] = useState();
  const [curPage, setCurPage] = useState();
  const [displayNotify, setDisplayNotify] = useState(false);

  useEffect(() => {
    setCurPage(1);
    let k = Math.round(data.length / 6);
    let i = 1;
    let arr = [];
    while (k > 0) {
      arr.push(i++);
      k--;
    }
    setPageNo(arr);
    let tmparr = [];
    for (let i = 0; i < 6 && i < data.length; i++) {
      tmparr.push(data[i]);
    }
    setArr(tmparr);
  }, []);

  const clickhandler = (i) => {
    if (i < 1) return;
    setCurPage(i);
    let tmparr = [];
    if (i == 1) {
      for (let j = 0; j < 6 && j < data.length; j++) {
        tmparr.push(data[j]);
      }
    } else {
      for (let j = (i - 1) * 6 - 1; j < i * 6 - 1 && j < data.length; j++) {
        tmparr.push(data[j]);
      }
    }
    if (tmparr != []) setArr(tmparr);
  };
  const SelectHand = (i) => {
    let newData;
    newData = data.map((item, id) => {
      if (id === i) {
        item.selected = item.selected ? false : true;
        return item;
      } else {
        return item;
      }
    });
    if (newData) setData(newData);
  };
  const NotifyClick = () => {
    setDisplayNotify(!displayNotify);
  };
  return (
    <div className="courselist">
      <Navbar page={t("LMSCourseBuilder")} />
      <div className="courselist-main">
        <Sidebar page={"LMSCourseBuilder"} hidepage={false} />
        <div className="courselist-main-cnt">
          <div className="courselist-main-cnt-top">
            <div className="courselist-main-cnt-top-txt">
              Internal Training LMS
            </div>

            <div>
              <Link to={"/admin/courseBuilder"}>
                <button
                  style={{
                    background: `${
                      clrs.CourseListBtn
                        ? clrs.CourseListBtn
                        : "hwb(224deg 78% 3%)"
                    }`,
                  }}
                >
                  Add New Internal Training LMS
                </button>
              </Link>
            </div>
          </div>
          <div className="courselist-main-cnt-bottom">
            <div className="courselist-main-cnt-bottom-heading">
              <div>Training Name</div>
              <div style={{ paddingLeft: "6vw" }}>Training Provider</div>
              <div style={{ paddingLeft: "7vw" }}>Action</div>
            </div>
            <div className="admin-overdue-bottom">
              <div className="admin-overdue-bottom-table">
                {arr &&
                  arr.map((item, id) => {
                    return (
                      <div
                        className="admin-overdue-bottom-table-cnt-c "
                        style={{
                          backgroundColor: `${
                            item.selected
                              ? "rgba(0, 69, 119, 0.1)"
                              : "rgba(255, 255, 255, 1)"
                          }`,
                        }}
                        key={id}
                      >
                        <div className="admin-overdue-bottom-table-td">
                          <Checkbox
                            checked={item.selected}
                            onClick={() => SelectHand(id)}
                          />
                        </div>
                        <div
                          className="admin-overdue-bottom-table-td"
                          style={{
                            display: "grid",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                          id="c-div"
                        >
                          {item.TrainingName}
                        </div>
                        <div
                          className="admin-overdue-bottom-table-td"
                          id="c-div"
                        >
                          {item.TrainingProvider}
                        </div>
                        <div
                          className="admin-overdue-bottom-table-td"
                          id="c-div"
                        >
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "3vw 3vw",
                            }}
                          >
                            <svg
                              width="auto"
                              height="27"
                              viewBox="0 0 27 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M25.25 6.125L20.875 1.75L3.375 19.25L1.625 25.375L7.75 23.625L25.25 6.125ZM17.375 5.25L21.75 9.625L17.375 5.25ZM3.375 19.25L7.75 23.625L3.375 19.25Z"
                                stroke="#717579"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            <svg
                              width="20"
                              height="24"
                              viewBox="0 0 20 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10 1.51734e-08C10.96 -8.629e-05 11.8835 0.368002 12.5802 1.02844C13.2769 1.68888 13.6938 2.59137 13.745 3.55L13.75 3.75H19.25C19.44 3.75006 19.6229 3.82224 19.7618 3.95197C19.9006 4.0817 19.9851 4.2593 19.998 4.44888C20.011 4.63846 19.9515 4.82589 19.8316 4.9733C19.7117 5.12071 19.5402 5.2171 19.352 5.243L19.25 5.25H18.191L16.971 20.303C16.8949 21.2421 16.4681 22.1181 15.7754 22.7568C15.0828 23.3955 14.1752 23.7501 13.233 23.75H6.767C5.82484 23.7501 4.91719 23.3955 4.22457 22.7568C3.53195 22.1181 3.10513 21.2421 3.029 20.303L1.808 5.25H0.75C0.568762 5.24999 0.393658 5.18436 0.25707 5.06523C0.120481 4.94611 0.0316483 4.78155 0.00699997 4.602L0 4.5C7.6429e-06 4.31876 0.0656429 4.14366 0.184767 4.00707C0.303892 3.87048 0.468446 3.78165 0.648 3.757L0.75 3.75H6.25C6.25 2.75544 6.64509 1.80161 7.34835 1.09835C8.05161 0.395088 9.00544 1.51734e-08 10 1.51734e-08ZM16.687 5.25H3.313L4.524 20.182C4.56973 20.7454 4.82587 21.271 5.24148 21.6542C5.65709 22.0374 6.2017 22.2501 6.767 22.25H13.233C13.7983 22.2501 14.3429 22.0374 14.7585 21.6542C15.1741 21.271 15.4303 20.7454 15.476 20.182L16.686 5.25H16.687ZM7.75 9C7.93124 9.00001 8.10634 9.06564 8.24293 9.18477C8.37952 9.30389 8.46835 9.46845 8.493 9.648L8.5 9.75V17.75C8.49994 17.94 8.42776 18.1229 8.29803 18.2618C8.1683 18.4006 7.9907 18.4851 7.80112 18.498C7.61154 18.511 7.42411 18.4515 7.2767 18.3316C7.12929 18.2117 7.0329 18.0402 7.007 17.852L7 17.75V9.75C7 9.55109 7.07902 9.36032 7.21967 9.21967C7.36032 9.07902 7.55109 9 7.75 9ZM12.25 9C12.4312 9.00001 12.6063 9.06564 12.7429 9.18477C12.8795 9.30389 12.9684 9.46845 12.993 9.648L13 9.75V17.75C12.9999 17.94 12.9278 18.1229 12.798 18.2618C12.6683 18.4006 12.4907 18.4851 12.3011 18.498C12.1115 18.511 11.9241 18.4515 11.7767 18.3316C11.6293 18.2117 11.5329 18.0402 11.507 17.852L11.5 17.75V9.75C11.5 9.55109 11.579 9.36032 11.7197 9.21967C11.8603 9.07902 12.0511 9 12.25 9ZM10 1.5C9.42987 1.49993 8.88098 1.7163 8.46425 2.10537C8.04751 2.49444 7.79402 3.02721 7.755 3.596L7.75 3.75H12.25L12.245 3.596C12.206 3.02721 11.9525 2.49444 11.5358 2.10537C11.119 1.7163 10.5701 1.49993 10 1.5Z"
                                fill="#717579"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className="admin-overdue-bottom-pagination">
                <div className="admin-overdue-bottom-pagination-cnt">
                  <div className="admin-overdue-bottom-pagination-cnt-item">
                    <svg
                      onClick={() => clickhandler(curPage - 1)}
                      width="auto"
                      height="22"
                      viewBox="0 0 14 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.0293 10.4584L12.1855 0.837334C12.6016 0.479912 13.2109 0.802178 13.2109 1.37933V20.6215C13.2109 21.1987 12.6016 21.5209 12.1855 21.1635L1.0293 11.5424C0.709961 11.267 0.709961 10.7338 1.0293 10.4584Z"
                        fill="#717579"
                      />
                    </svg>
                  </div>
                  <div
                    className="admin-overdue-bottom-pagination-cnt-item-btn"
                    style={{
                      gridTemplateColumns: `repeat(${
                        pageNo && (pageNo.length > 5 ? 5 : pageNo.length)
                      },1fr)`,
                    }}
                  >
                    {pageNo &&
                      pageNo.map((item, id) => {
                        if (id < 3) {
                          return (
                            <button
                              key={id}
                              onClick={() => clickhandler(item)}
                              className="admin-overdue-bottom-pagination-cnt-item"
                            >
                              {item}
                            </button>
                          );
                        } else if (id == 4) {
                          return (
                            <div
                              className="admin-overdue-bottom-pagination-cnt-item"
                              key={id}
                            >
                              <svg
                                width="auto "
                                height="4"
                                viewBox="0 0 12 4"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M2 3.08C1.63733 3.08 1.344 2.968 1.12 2.744C0.906667 2.52 0.8 2.232 0.8 1.88C0.8 1.53867 0.906667 1.26133 1.12 1.048C1.344 0.824 1.63733 0.712 2 0.712C2.37333 0.712 2.66133 0.824 2.864 1.048C3.07733 1.26133 3.184 1.53867 3.184 1.88C3.184 2.232 3.07733 2.52 2.864 2.744C2.66133 2.968 2.37333 3.08 2 3.08ZM5.96875 3.08C5.60608 3.08 5.31275 2.968 5.08875 2.744C4.87542 2.52 4.76875 2.232 4.76875 1.88C4.76875 1.53867 4.87542 1.26133 5.08875 1.048C5.31275 0.824 5.60608 0.712 5.96875 0.712C6.34208 0.712 6.63008 0.824 6.83275 1.048C7.04608 1.26133 7.15275 1.53867 7.15275 1.88C7.15275 2.232 7.04608 2.52 6.83275 2.744C6.63008 2.968 6.34208 3.08 5.96875 3.08ZM9.9375 3.08C9.57483 3.08 9.2815 2.968 9.0575 2.744C8.84417 2.52 8.7375 2.232 8.7375 1.88C8.7375 1.53867 8.84417 1.26133 9.0575 1.048C9.2815 0.824 9.57483 0.712 9.9375 0.712C10.3108 0.712 10.5988 0.824 10.8015 1.048C11.0148 1.26133 11.1215 1.53867 11.1215 1.88C11.1215 2.232 11.0148 2.52 10.8015 2.744C10.5988 2.968 10.3108 3.08 9.9375 3.08Z"
                                  fill="#717579"
                                />
                              </svg>
                            </div>
                          );
                        } else if (id + 1 == pageNo.length) {
                          return (
                            <button
                              key={id}
                              onClick={() => clickhandler(item)}
                              className="admin-overdue-bottom-pagination-cnt-item"
                            >
                              {item}
                            </button>
                          );
                        }
                      })}
                  </div>
                  <div className="admin-overdue-bottom-pagination-cnt-item">
                    <svg
                      onClick={() => clickhandler(curPage + 1)}
                      width="auto"
                      height="20"
                      viewBox="0 0 13 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.1816 9.22727L1.02539 0.141497C0.609375 -0.196038 0 0.108297 0 0.653332V18.8249C0 19.3699 0.609375 19.6742 1.02539 19.3367L12.1816 10.2509C12.501 9.99087 12.501 9.48733 12.1816 9.22727Z"
                        fill="#717579"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <Link to={"/admin/coursecreation"}>
              <button>Course Creation</button>
            </Link>
          </div>
          <div className="courselist-main-cnt-back">
            <div className="courselist-main-cnt-back-btn">
              <button
                style={{
                  background: `${
                    clrs.CourseListBtn
                      ? clrs.CourseListBtn
                      : "hwb(224deg 78% 3%)"
                  }`,
                }}
              >
                Back
              </button>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CourseList;
